export default __webpack_public_path__ + "static/media/boro-punk-blue-bg.52e0d37e.png";